/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/updateProfile.config.json";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_BANK_DETAIL } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateBankDetailMethods extends IPluginMethodMap {
  getUpdateBankDetail(args: any): Promise<any>;
}

export interface UpdateBankDetailProps {
  cnfAccountNumber: string;
  bankName: string;
  accHolderName: string;
  accountNo: string;
  swiftCode: string;
  type: string;
}

export class UpdateBankDetailService implements IAgentPlugin {
  readonly methods: IUpdateBankDetailMethods;
  constructor() {
    this.methods = {
      getUpdateBankDetail: this.getUpdateBankDetail.bind(this),
    };
  }

  async getUpdateBankDetail(args: UpdateBankDetailProps) {
    console.log("data in mutation", args);
    const graphqlModule = getGraphQLModule();
    delete args?.cnfAccountNumber;
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_BANK_DETAIL,
          variables: {
            input: {
              ...args,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    return { data: config };
  }
}
